import Service from "./Service";

class BusAdministrationApiService extends Service {
  constructor() {
    super("api/BusAdministration");
  }

  async getBusStations() {
    let result = await this.get(`/BusStations`, (status, data) => {
      return data;
    });
    return result;
  }

  async getTrainStations() {
    let result = await this.get(`/GetTrainStations`, (status, data) => {
      return data;
    });
    return result;
  }
}

export default new BusAdministrationApiService();
